/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

/**
 * Enumeration of return codes for the SysQue gauge.
 */
export enum SysQueGaugeReturnCodes {
  Success = 0,
  NoSelection = 1,
  NotValidSelection = 3,
  Reset = 4,
  ResetAll = 5,
  FaceBased = 6,
  ShowAcrylicSurface = 7,
}
